const routes = {
    top: '/',
    privacy: '/privacy',
    contact: '/contact'
  }


export default routes;